import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import FeaturesBar from './components/FeaturesBar';
import BestSellers from './components/BestSellers';
import FeaturedProducts from './components/FeaturedProducts';
import PerfumeCollection from './components/PerfumeCollection';
import FashionCollection from './components/FashionCollection';
import WhatsAppCTA from './components/WhatsAppCTA';
import Testimonials from './components/Testimonials';
import AboutUs from './components/AboutUs';
import ContactSection from './components/ContactSection';
import SiteFooter from '../../components/feature/SiteFooter';
import FloatingWhatsApp from '../../components/feature/FloatingWhatsApp';

const JSON_LD_LOCAL_BUSINESS = {
  "@context": "https://schema.org",
  "@type": "ClothingStore",
  "name": "Laura Soto Shop",
  "description": "Tienda online de ropa femenina y perfumes originales en Villavicencio, Colombia. Vestidos, conjuntos, sets y fragancias importadas con envíos nacionales.",
  "url": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/`,
  "logo": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/og-image.jpg`,
  "image": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/og-image.jpg`,
  "telephone": "+573228000501",
  "email": "sotovalderramalaurayisel@gmail.com",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Villavicencio",
    "addressRegion": "Meta",
    "addressCountry": "CO"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 4.142,
    "longitude": -73.626
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
      "opens": "09:00",
      "closes": "20:00"
    }
  ],
  "sameAs": [],
  "priceRange": "$$",
  "currenciesAccepted": "COP",
  "paymentAccepted": "Cash, Transfer, WhatsApp"
};

const JSON_LD_WEBSITE = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Laura Soto Shop",
  "url": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/`,
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

export default function HomePage() {
  useEffect(() => {
    const ids = ['ld-local-business', 'ld-website'];
    ids.forEach((id) => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    });

    const lbScript = document.createElement('script');
    lbScript.type = 'application/ld+json';
    lbScript.id = 'ld-local-business';
    lbScript.text = JSON.stringify(JSON_LD_LOCAL_BUSINESS);
    document.head.appendChild(lbScript);

    const wsScript = document.createElement('script');
    wsScript.type = 'application/ld+json';
    wsScript.id = 'ld-website';
    wsScript.text = JSON.stringify(JSON_LD_WEBSITE);
    document.head.appendChild(wsScript);

    document.title = 'Laura Soto Shop | Ropa y Perfumes Originales en Villavicencio';

    return () => {
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <FeaturesBar />
      <BestSellers />
      <FeaturedProducts />
      <PerfumeCollection />
      <FashionCollection />
      <WhatsAppCTA />
      <Testimonials />
      <AboutUs />
      <ContactSection />
      <SiteFooter />
      <FloatingWhatsApp />
    </div>
  );
}
